module.exports = __webpack_public_path__ + "static/img/13062B_X_04_20170621_LC.5b33364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13062B_X_04_20170621_LC.png
// module id = KQQW
// module chunks = 0